import * as React from "react";
import ReadService from "../../../../service/read";
import Wait from "../../../wait";
import baseURL from "../../../../service/baseURL";
import CreateService from "../../../../service/create";
import PopDetail from "../../../popdetail";

export default class CCRODocumentPane extends React.Component {


    constructor(props) {
        super(props);


        this.state = {
            docs: [],
            data: [],
            current_file: {},
            current_tab:0,
            output:'',
            current_doc: 'Loading...'
        }

        this.loadData = this.loadData.bind(this)
        this.showDoc = this.showDoc.bind(this)
        this.showTabAt = this.showTabAt.bind(this)
        this.markPrinted = this.markPrinted.bind(this)
        this.waitDoc = this.waitDoc.bind(this)

    }

    markPrinted(){
        try{
            CreateService.markPrinted({
                parcel_id:this.props.parcel.id,
                stage:'printed'
            }).then(r => {
                PopDetail.dismiss()
            })
        }catch (e) {
            console.log(e)
        }
    }

    componentDidMount() {
        if (this.props.parcel.stage==='registered'){
            this.loadData()
        }else{
            this.setState({
                current_doc:<div style={{padding:'32px',background:'#fee',borderRadius:'4px',fontSize:'20px',margin:'42px',border:'1px solid #eee'}}>
                    Stage : <span className={'label'}>{this.props.parcel.stage}</span><br/>
                    <i style={{color:'#f00'}}><span className={'fa fa-warning'}/>No Documents at this Stage</i>
                </div>
            })
        }

    }

    showTabAt(d, i) {
        this.setState({
            current_tab: i,
            current_village: d
        })
    }

    render() {
        return (<div>

            <div className={'row'}>
                <div className={'col col-sm-3'} style={{height: '68vh',background:'#efefef', padding: 0}}>
                    <div className={'col col-sm-12'}
                         style={{height: '50%',  padding: 0}}>
                        <div style={{fontSize: '16px', background: 'linear-gradient(#fff,#ccc)', padding: '4px 24px'}}>
                            Available Documents
                        </div>

                        <br/>
                       {this.state.data.map((d, i) => {
                                return (<div key={i} className={i===this.state.current_tab?'btn-left-menu btn-left-menu-active':'btn-left-menu'}
                                             onClick={() => this.showDoc(d,i)}>
                                    <div><span className={'fa fa-check'}/>
                                    <b>{d.name}</b>
                                    </div>
                                    <div style={{color:'#f00'}}>
                                        <span className={'fa fa-check'} style={{visibility:'hidden'}}/>
                                        <span>{d.datetime}</span>
                                    </div>
                                </div>)
                            })}
                    </div>
                    <hr/>
                    <div style={{textAlign:'center',display:this.props.parcel.stage==='registered'?'inherit':'none'}} onClick={this.markPrinted}>
                         <button className={'btn error'}>
                             <span className={'fa fa-print'}/>Mark as Printed
                         </button>
                    </div>
                </div>
                <div className={'col col-sm-9'} style={{height: '68vh', padding: 0, border: '1px solid #ccc'}}>

                    {this.state.current_doc}


                </div>

            </div>

        </div>)
    }

    loadData() {
        try {
            Wait.show('Fetching Documents...')
            ReadService.fetchDocuments(this.props.parcel.id).then(r => {
                Wait.dismiss()
                let results = r.data.results
                try{
                    let path = results[0].file
                    this.setState({
                        data:results,
                        current_doc:<div style={{height:'60vh'}}><embed style={{height:'100%', width:'100%'}} src={path}/></div>
                    })

                    this.showDoc('',0)
                }catch (e) {
                    console.log(e)
                }

            })
        } catch (e) {
            console.log(e)
        }
    }


    waitDoc(task_id) {
        Wait.show('Rendering...')
        CreateService.askDownloadSHPStatus(task_id).then(d => {
            try {
                console.log(d.data)
                let task_status = d.data.state

                if (task_status === 'PENDING' || task_status === 'STARTED') {
                    setTimeout(() => this.waitDoc(task_id), 1000);
                } else if (task_status === 'SUCCESS') {
                    console.log('woyooo 2')
                    Wait.dismiss()
                    let path = this.state.output
                    console.log(path)
                    this.setState({
                        current_doc: <object>
                            <embed id="pdfID" type="text/html" width="100%" height="100%" src={path}/>
                        </object>
                    })

                } else {
                    Wait.dismiss()
                    console.error('Task failed:');
                }
            } catch (e) {
                console.log(e)
            }
        }).catch(e=>{
            console.log(e)
            Wait.dismiss()
        })
    }


    showDoc(d,i) {
        Wait.show('Loading...')
        ReadService.generateDocument({
            parcel_id:this.props.parcel.id,
            document:i
        }).then(r=>{
            Wait.dismiss()

            console.log('HRRRR')
            console.log(r.data)
            this.setState({
                output:r.data.output
            })
            let task_id = r.data.task_id

            this.waitDoc(task_id)





           /* let refreshIntervalId = setInterval(()=>{
                        CreateService.askDownloadSHPStatus(r.data.task_id).then(d=>{
                            let data = d.data
                            let progression = data.progression
                            let state = data.state

                            Wait.show(`Tafadhali Subiri....${progression}% => ${state}`)

                            if(data.progression>96.0){

                                clearInterval(refreshIntervalId)
                                Wait.show('Inamalizia....100%')
                                setTimeout(()=>{
                                    Wait.dismiss()
                                //window.location = 'http://154.118.227.140/downloads'
                                    //window.open(`http://154.118.227.140/downloads/${r.data.locality_name}`, "", "width=1200,height=600");
                                },10000)

                            }

                            if (progression==='None'){
                                Wait.dismiss()
                                clearInterval(refreshIntervalId)
                            }

                        })
                    },2000)*/

            /*try {
                let path = r.data.path.path.replace('0.0.0.0','154.118.227.140')
                  this.setState({
                    current_file: d,
                    current_tab:i,
                    current_doc: <object>
                        <embed id="pdfID" type="text/html" width="100%" height="100%" src={path}/>
                    </object>
                })
            }catch (e) {
                console.log(e)
            }*/
        })
        console.log(d)
        /*this.setState({
            current_file: d,
            current_tab:i,
            current_doc: <object>
                <embed id="pdfID" type="text/html" width="100%" height="100%" src={d.file}/>
            </object>
        })*/
    }

}

    
